<div class="container">

    <button #focusableEleTop class="focusable-element"></button>
    <div class="row" *ngIf="hasError">
        <div class="col-24">
            <div class="alert danger">
                <p><em>Error Message:</em></p>
                <ul>
                    <li *ngFor="let error of ErrorMessages"><button>{{error}}</button></li>
                </ul>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <p class="required">Todos los campos son obligatorios, a menos que estén marcados como opcionales.</p>
        </div>
    </div>
    <div *ngIf="false">
        <!--<div *ngIf="Isdisplay">-->
        <div class="row">
            <div class="col-24">
                <h1 class="medium">Section 2: Beneficiary Information</h1>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <p class="blue-text bottom-20">May I please have the Medicare beneficiary’s title, first name, last name, gender, phone number, permanent address and email address?</p>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <p class="qtip-note bottom-20"><strong>qTip Note:</strong> Copy and paste below from WordPad when Medicare Number was initially captured, then verify accuracy from caller information provided.</p>
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <div class="input-wrapper">
                    <ValidatedDropDown [label]="'Title'"
                                       [options]="titleOptions"
                                       [selectedValue]="enrollmentViewModel.TITLE"
                                       (onValueChange)="enrollmentViewModel.TITLE = $event"
                                       [disabled]="disabled">
                    </ValidatedDropDown>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField label="First Name"
                                        [id]="'first-name'"
                                        [text]="enrollmentViewModel.APPFN"
                                        (onValueChange)="enrollmentViewModel.APPFN = $event"
                                        [validators]="[notBlankValidator]"
                                        [disabled]="disabled">
                    </ValidatedTextField>
                </div>
            </div>
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField label="Last Name"
                                        [id]="'last-name'"
                                        [text]="enrollmentViewModel.APPLN"
                                        (onValueChange)="enrollmentViewModel.APPLN = $event"
                                        [validators]="[notBlankValidator]"
                                        [disabled]="disabled">
                    </ValidatedTextField>
                </div>
            </div>

        </div>
        <div class="row">
            <div class="col-16">
                <div class="input-wrapper bottom-20">
                    <fieldset class="radio">
                        <legend>Gender</legend>
                        <ValidatedRadioButtonGroup [label]="''"
                                                   [options]="genderOptions"
                                                   [selectedValue]="enrollmentViewModel.APPGEN"
                                                   [radioGroupName]="genderOptions"
                                                   (onValueChange)="enrollmentViewModel.APPGEN = $event"
                                                   [disabled]="disabled">
                        </ValidatedRadioButtonGroup>
                    </fieldset>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField label="Phone Number (numbers only)"
                                        [id]="'phone-number'"
                                        [maxlength]="10"
                                        [text]="enrollmentViewModel.APPPHONE"
                                        (onValueChange)="enrollmentViewModel.APPPHONE = $event"
                                        [validators]="[numericTextFieldValidator,lengthValidator]"
                                        [disabled]="disabled">
                    </ValidatedTextField>
                </div>
            </div>
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'Permanent Address'"
                                        [id]="'permanent-address'"
                                        [text]="enrollmentViewModel.APPADD1"
                                        [validators]="[notBlankValidator]"
                                        [disabled]="disabled"
                                        (onValueChange)="enrollmentViewModel.APPADD1 = $event" maxlength="150">
                    </ValidatedTextField>
                </div>
            </div>
        </div>


        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'City'"
                                        [id]="'city'"
                                        [text]="enrollmentViewModel.APPCITY"
                                        [validators]="[notBlankValidator]"
                                        [disabled]="disabled"
                                        (onValueChange)="enrollmentViewModel.APPCITY= $event" maxlength="50">
                    </ValidatedTextField>
                </div>
            </div>
            <div class="col-5">
                <div class="input-wrapper">
                    <ValidatedDropDown class="wide"
                                       [selectedValue]="enrollmentViewModel.APPST"
                                       [label]="'State'"
                                       [disabled]="disabled"
                                       [options]="states"
                                       (onValueChange)="enrollmentViewModel.APPST= $event">
                    </ValidatedDropDown>
                </div>
            </div>
            <div class="col-3">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'ZIP'"
                                        [id]="'zip'"
                                        [text]="enrollmentViewModel.APPZIP"
                                        [validators]="[notBlankValidator, numericTextFieldValidator]"
                                        [disabled]="disabled"
                                        (onValueChange)="enrollmentViewModel.APPZIP = $event" maxlength="5">
                    </ValidatedTextField>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField class=""
                                        [label]="'Email Address(required)'"
                                        [id]="'EmailAddress'"
                                        [text]="enrollmentViewModel.APPEMAIL"
                                        (onValueChange)="enrollmentViewModel.APPEMAIL = $event"
                                        [validators]="[notBlankValidator]">
                    </ValidatedTextField>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-24">
                <button class="button primary" (click)="Continue()">Continue</button>
            </div>
        </div>
    </div>
    <!--<div *ngIf="IsContentdisplay">-->
    <!--<div *ngIf="!ShowCurrentYearScript">

        <div class="row">
            <div class="col-24">
                <h1 class="medium">Section 6. Enrollment End</h1>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <p class="blue-text">{{CallerName}} I’d like to thank you once again for contacting SilverScript, I hope all of your questions were answered.</p>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <p class="qtip-note bottom-20"><strong>{{qtipNote}}</strong> If email was not previously captured and populated below, please ask caller if they wish to include an email address for information pertaining to Part D Enrollment.</p>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <p class="blue-text">&lt;Would you like to provide/ I’d like to verify&gt; your email address and phone number, so that we may communicate plan information and reminders about Medicare’s enrollment periods? By providing us with your email address, you agree to receive email communications from SilverScript until you opt-out of further emails. You have the opportunity to opt-out at any time.</p>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <p class="qtip-note bottom-20">
                    <strong>{{qtipNote}}</strong> If enrollee/legally authorized representative indicate interest in receiving communications, &lt; capture, verify &gt;
                    the email address. If no, continue with script.
                </p>
                <ValidatedRadioButtonGroup [label]="''"
                                           [options]="rblEmailPhoneReminder"
                                           [selectedValue]="rblEmailPhoneReminder"
                                           [radioGroupName]="'rblEmailPhoneReminder'"
                                           (onValueChange)="ShowGroupOptionsPhoneReminder($event)">
                </ValidatedRadioButtonGroup>
            </div>
        </div>

        <div *ngIf="IsEmailPhoneReminderYes">
            <div class="row">
                <div class="col-16">
                    <p class="qtip-note bottom-20"><strong>{{qtipNote}}</strong> Enter email address and/or phone, while verifying verbally:</p>
                </div>
            </div>

            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedTextField class=""
                                            [label]="'Email address'"
                                            [id]="'EmailAddress'"
                                            [text]="enrollmentViewModel.APPEMAIL"
                                            (onValueChange)="enrollmentViewModel.APPEMAIL = $event"
                                            [validators]="[notBlankValidator]">
                        </ValidatedTextField>
                    </div>
                </div>
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedCheckbox class="centered-checkbox"
                                           [label]="'Decline to provide email'"
                                           [id]="'Decline to provide email'"
                                           [checked]="DeclineProvEmail"
                                           (onValueChange)="DeclineProvEmail= $event">
                        </ValidatedCheckbox>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedTextField [label]="'Phone Number'"
                                            [id]="'phone-number'"
                                            [text]="enrollment.AUTHREPPHONE"
                                            [maxlength]="10"
                                            (onValueChange)="enrollment.AUTHREPPHONE = $event"
                                            [validators]="[numericTextFieldValidator,lengthValidator]">
                        </ValidatedTextField>
                    </div>
                </div>
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedCheckbox class="centered-checkbox"
                                           [label]="'Decline to provide phone number'"
                                           [id]="'Decline to provide phone number'"
                                           [checked]="DeclineProvPhone"
                                           (onValueChange)="DeclineProvPhone= $event">
                        </ValidatedCheckbox>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-16">
                    <fieldset class="radio">
                        <legend class="blue-text">To confirm, do you grant permission for us to contact you in the future by &lt;email and/or phone&gt; so that we may communicate plan information and reminders about Medicare’s enrollment periods?  By providing us with your email address, you agree to receive email communications from SilverScript until you opt-out of further emails.  You have the opportunity to opt-out at any time.</legend>
                        <ValidatedRadioButtonGroup [label]="''"
                                                   [options]="rblPermissionToContact"
                                                   [selectedValue]="rblPermissionToContact"
                                                   [radioGroupName]="'rblPermissionToContact'"
                                                   (onValueChange)="ShowGroupOptionsPermissionToContact($event)">
                        </ValidatedRadioButtonGroup>
                    </fieldset>
                </div>
            </div>
        </div>

        <div *ngIf="IsEmailPhoneReminderNo">
            <div class="row">
                <div class="col-16">
                    <p class="blue-text bottom-20">Please remember that you can reach us &lt;HOO&gt; week at 855-771-9286 TTY: 711 or visit us online at <a class="link" href="https://www.silverscript.com" target="_blank">www.silverscript.com</a> . If you have no other questions today, I’d like to thank you for calling SilverScript; have a wonderful day!</p>
                </div>
            </div>
            <div class="row">
                <div class="col-16">
                    <div class="bottom-20">
                        <ValidatedDropDown [label]="'Final Disposition'"
                                           [disabled]="'false'"
                                           [options]="dispositionDropDown"
                                           (onValueChange)="this.DispositionId = $event">
                        </ValidatedDropDown>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-24">
                    <button class="button primary" (click)="EndCall()">End Call</button>
                </div>
            </div>
        </div>
    </div>-->
    <div>

        <div class="row">
            <div class="col-24">
                <h1 class="medium">Section 7. Enrollment End</h1>
            </div>
        </div>
        <div class="row">
            <div class="col-16" *ngIf="ShowCurrentYearScript">
                <p class="blue-text">{{CallerName}} le agradezco una vez más por comunicarse con Aetna; espero haber respondido todas sus preguntas. </p>
            </div>
            <div class="col-16" *ngIf="!ShowCurrentYearScript">
                <p class="blue-text">{{CallerName}} le agradezco una vez más por comunicarse con Aetna. Espero haber respondido todas sus preguntas. </p>
            </div>
            <!--<div class="col-16" *ngIf="!ShowCurrentYearScript">
        <p class="blue-text">{{CallerName}} I’d like to thank you once again for contacting Aetna, I hope all of your questions were answered.</p>
    </div>-->
        </div>
        <div class="row">
            <div class="col-16">
                <p class="blue-text bottom-20" *ngIf="ShowCurrentYearScript">Recuerde que puede llamarnos las 24 horas al día, 7 días a la semana al 866-235-5660 TTY: 711 o visitarnos en <a class="link" href="https://www.AetnaMedicare.com" target="_blank">www.AetnaMedicare.com</a>.  Si no tiene más preguntas hoy, quisiera agradecerle por llamar a Aetna; que tenga un buen día.</p>
                <p class="blue-text bottom-20" *ngIf="!ShowCurrentYearScript">Recuerde que puede llamarnos las 24 horas al día, 7 días a la semana al 866-235-5660 TTY: 711 o ingresar en nuestro sitio web, <a class="link" href="https://www.AetnaMedicare.com" target="_blank">www.AetnaMedicare.com</a>.  Si no tiene más preguntas hoy, quisiera agradecerle por llamar a Aetna. Que tenga un buen día.</p>
            </div>
            <!--<div class="col-16" *ngIf="!ShowCurrentYearScript">
                <p class="blue-text bottom-20">Please remember that you can reach us &lt;HOO&gt; week at 866-235-5660 TTY: 711 or visit us online at <a class="link" href="https://www.aetnamedicare.com" target="_blank">www.aetnamedicare.com</a> . If you have no other questions today, I’d like to thank you for calling Aetna; have a wonderful day!</p>
            </div>-->
        </div>
        <div class="row">
            <div class="col-16">
                <div class="bottom-20">
                    <ValidatedDropDown [label]="'Final Disposition'"
                                       [disabled]="'false'"
                                       [options]="dispositionDropDown"
                                       (onValueChange)="this.DispositionId = $event">
                    </ValidatedDropDown>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <button class="button primary" (click)="EndCall()">End Call</button>
            </div>
        </div>
    </div>
    <!--</div>-->

</div>